import type { Random } from '../core/Random';
import type { Outcome } from '../state/Store';

interface MailDef {
  weight: number;
  outcome: (rng: Random) => Outcome;
}

const MAIL: readonly MailDef[] = [
  {
    weight: 3,
    outcome: () => ({
      text: 'A credit card offer: "You\'re PRE-APPROVED! 39.99% APR!" You feel seen, and also hunted.',
    }),
  },
  {
    weight: 2,
    outcome: () => ({
      text: 'A free scratch-off from Gas-N-Grub\'s "Loyal Customer" mailer. They know you by name.',
      items: { scratcher: 1 },
    }),
  },
  {
    weight: 1,
    outcome: () => ({
      text: "A birthday card from Mee-Maw with $20 inside. It isn't your birthday. Don't tell her.",
      money: 20,
    }),
  },
  {
    weight: 2,
    outcome: () => ({ text: 'A jury summons. You stick it on the fridge with the other jury summonses.' }),
  },
  {
    weight: 2,
    outcome: () => ({
      text: "A letter for Dale stamped FINAL NOTICE in red. You slide it under his door. He'll use it as a coaster.",
    }),
  },
  {
    weight: 2,
    outcome: () => ({
      text: '"YOU MAY ALREADY BE A WINNER!" You check. You are not already a winner.',
    }),
  },
  {
    weight: 1,
    outcome: () => ({
      text: 'A class-action settlement check for $4.17 from a lawsuit about pickle jars. Justice.',
      money: 4.17,
    }),
  },
  {
    weight: 2,
    outcome: () => ({
      text: "A postcard from your cousin in Florida. It's his mugshot. He looks happy.",
      clout: 1,
    }),
  },
  {
    weight: 2,
    outcome: (rng) => ({
      text: `A coupon book. Inside: $1 off a 12-pack, expired in ${rng.int(2014, 2021)}. You keep it anyway.`,
    }),
  },
  {
    weight: 1,
    outcome: () => ({
      text: 'Junk mail from a dealership: "TRADE IN YOUR CAMARO!" They have clearly never seen your Camaro.',
    }),
  },
];

export function drawMail(rng: Random): Outcome {
  const def = rng.weighted(MAIL, (m) => m.weight) ?? (MAIL[0] as MailDef);
  return def.outcome(rng);
}
